const themeColors = {
  primary: "#034E95", // main brand (buttons, links)
  secondary: "#0ea5e9", // accents, highlights

  background: "#f9fafb", // app background
  surface: "#ffffff", // cards, navbar, sidebar

  textPrimary: "#111827", // headings, main text
  textSecondary: "#6b7280", // muted text, labels

  border: "#e5e7eb", // borders, dividers

  buttonPrimary: "#2563eb",
  buttonPrimaryHover: "#1d4ed8",
  buttonSecondary: "#e5e7eb",
  buttonSecondaryHover: "#d1d5db",

  success: "#22c55e",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#38bdf8",
};

export default themeColors;
